import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import CommentSection from 'app/components/layouts/Comments/CommentSection';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import GoogleAdsense from 'app/components/layouts/Ads/GoogleAdsense';
import { faRandom } from "@fortawesome/free-solid-svg-icons";
import { useState, useRef, useMemo, useEffect } from 'react';
import { withGlobalData } from 'app/utils/withGlobalData';
import ListJokes from 'app/components/jokes/ListJokes';
import Image from 'app/components/layouts/Image';
import Title from 'app/components/layouts/Title';
import { ResultAPI } from 'app/requests/apiRequest';
import { useTranslation } from 'next-i18next';
import * as listenApi from 'app/requests/listens';
import { Translate } from 'types/commons';
import { useRouter } from "next/router";
import { NextSeo } from 'next-seo';
import env from '.env.json';
import 'app/components/listening/styles.css';

export default function ListenDetail({ joke }) {
  if (!joke) return <></>

  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [isLoop, setIsLoop] = useState(false);
  const [jokes, setJokes] = useState([]);
  const audioPlayer = useRef<any>(undefined);
  const router = useRouter();
  const code = router?.locale == 'en' ? env.DEFAULT_LOCALE : router?.locale!;

  useEffect(() => {
    fetchJokes();
  }, []);

  const fetchJokes = async () => {
    const result = await listenApi.getJokes({
      direction: 'desc',
      limit: 18,
      random: true,
      code,
    }) as ResultAPI;

    setJokes(result.data)
  }

  const toggleAutoReplay = () => {
    audioPlayer.current.loop = !isLoop;
    setIsLoop(!isLoop)
  }

  const title = useMemo(() => {
    return joke.translates.find((translate: Translate) => translate.type == 'title');
  }, [joke]);

  const lyrics = useMemo(() => {
    return joke.translates.filter((translate: Translate) => translate.type == 'lyric');
  }, [joke]);

  return (
    <section className="box-card-area list-test song-detail" id="jokeDetailPage">
      <NextSeo
        title={title.en}
        description={title.en + ' ' + title[code]}
        additionalMetaTags={[{
          name: 'keywords',
          content: `truyện cười tiếng anh, học tiếng anh qua truyện cười, joke english`
        }]}
      />
      <div className="container-md" id="joke">
        <div className="d-flex">
          <div className="box-news-area">
            <div className='content_inner'>
              <Title title={title.en} />
              <p
                className='text-center text-info'
                dangerouslySetInnerHTML={{ __html: title[code] }}
              />
              <div className="form-group text-center mt-2">
                <audio
                  key={joke.slug}
                  ref={audioPlayer}
                  style={{ minWidth: '70%' }}
                  controlsList="nodownload"
                  className="mt-2" controls
                >
                  <source src={`${env.URL_API_FILE}/${joke.audio_url}`} />
                </audio>
                <div className="d-flex justify-content-center mt-2">
                  <button onClick={() => setVisible(!visible)} className="btn btn-info mr-2">
                    {visible ? t('listening.turn_off_translate') : t('listening.turn_on_translate')}
                  </button>
                  <button onClick={() => toggleAutoReplay()} className="btn btn-success">
                    {isLoop ? t('listening.turn_off_auto_replay') : t('listening.turn_on_auto_replay')}
                  </button>
                </div>
              </div>
              <div className="form-group mt-2">
                <Image
                  className="mx-auto d-block my-4"
                  alt={joke.title_en}
                  style={{ maxWidth: 400, width: '100%' }}
                  src={`${env.URL_API_FILE}/${joke.image_url}`}
                />
                {lyrics.map((item: Translate, index: number) => {
                  return (
                    <div key={index} className={`play_audio_part mt-2 mx-3`}>
                      <div className="text_speak position-relative">
                        <span
                          className={`text-ta ${!visible ? 'cursor-pointer tool-tip' : ''}`}
                          title-new={item[code]}
                        >
                          {item.en}
                        </span>
                        <small className="text-size-sm">
                          <i className={`text-translate ${visible ? 'show' : ''}`}>{item.vi}</i>
                        </small>
                      </div>
                    </div>
                  )
                })}
                <GoogleAdsense width="100%" dataSlot="7482232136" />
                {joke.note &&
                  <>
                    <h5 className='mt-3 text-success text-center'>Grammar Note</h5>
                    <span dangerouslySetInnerHTML={{ __html: joke.note }} />
                  </>
                }
              </div>
              <div className="note mt-3">
                <h4 className="text-info mb-3 text-center">
                  <FontAwesomeIcon className="pr-3 text-warning"  icon={faRandom} />
                  {t('jokes.random')}
                </h4>
                <div className="mt-4">
                  <ListJokes jokes={jokes} code={code} />
                </div>
              </div>
            </div>
            <CommentSection roomId={`joke-id-${joke?.id}`} />
          </div>
          <RightContent />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query }) => {
  const fallbackLocale = locale === 'en' ? 'vi' : locale;

  try {
    const [joke, translations] = await Promise.all([
      listenApi.infoJoke(query.slug, fallbackLocale),
      serverSideTranslations(locale, ['common', 'joke-detail'])
    ]);

    if (!joke) {
      return { notFound: true };
    }

    return {
      props: {
        ...translations,
        joke
      }
    };
  } catch (error) {
    console.error('Error loading joke or translations:', error);
    return { notFound: true };
  }
});

